var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResourceAction',{ref:"resource",attrs:{"action":_vm.action,"params":_vm.params,"debounce":_vm.debounce},on:{"error":function($event){return _vm.$emit('error', $event.error)},"success":_vm.onSuccess,"update:isLoading":_vm.onLoadingUpdate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isLoading = ref.isLoading;
var error = ref.error;
return [_vm._t("default",null,{"isLoading":isLoading,"loadingPage":_vm.pagination.loadingPage,"error":error})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }